import {setLatestUpdates_actionType} from "../constants";

export const setLatestUpdates = (payload) => ({
  type: setLatestUpdates_actionType,
  payload
})